module.exports = __webpack_public_path__ + "img/luojigouMini.60a8b8de.png";